/* tslint:disable */
/* eslint-disable */
/**
 * Контроль місій для FPV
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface OutputAdminElementRoom
 */
export interface OutputAdminElementRoom {
    /**
     * 
     * @type {string}
     * @memberof OutputAdminElementRoom
     */
    id?: string;
    /**
     * 
     * @type {string}
     * @memberof OutputAdminElementRoom
     */
    name?: string;
}

/**
 * Check if a given object implements the OutputAdminElementRoom interface.
 */
export function instanceOfOutputAdminElementRoom(value: object): boolean {
    return true;
}

export function OutputAdminElementRoomFromJSON(json: any): OutputAdminElementRoom {
    return OutputAdminElementRoomFromJSONTyped(json, false);
}

export function OutputAdminElementRoomFromJSONTyped(json: any, ignoreDiscriminator: boolean): OutputAdminElementRoom {
    if (json == null) {
        return json;
    }
    return {
        
        'id': json['id'] == null ? undefined : json['id'],
        'name': json['name'] == null ? undefined : json['name'],
    };
}

export function OutputAdminElementRoomToJSON(value?: OutputAdminElementRoom | null): any {
    if (value == null) {
        return value;
    }
    return {
        
        'id': value['id'],
        'name': value['name'],
    };
}

